import { NgIf } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'tag-list',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './tag-list.component.html',
  styleUrl: './tag-list.component.scss'
})
export class TagListComponent {
  tagTitle = input<string>();
  tagList = input<string[]>([]);

  // Output untuk komunikasi dengan parent component
  promoInteraction = output<{action: string, label?: string}>();

  onTagClick(tag: string) {
    // Track tag click interaction
    this.promoInteraction.emit({
      action: 'tag_click',
      label: tag
    });
  }
}
